import React from 'react';
import "./Verid.scss";
import "./../Common/common.scss";
import IDVButton from "./../Common/IDVButton";
import Kbv from './../KBV/Kbv';
import { connect } from "react-redux";
import { getVeridQuestions, submitVerid } from './../../../actions/crossSellApplicationActions';
import { addBankDetailsUrl } from './../Constants/urls';
import { Redirect } from 'react-router';
import { veridDataLayer } from "./../../../analytics/adobe/dataLayerValues";
import { updateStandardDataLayerAttributes, setPageNameSiteSection } from "./../../../analytics/adobe/index";

class Verid extends React.Component {

  state = {
    veridData: this.props.veridQuestions&&!this.props.veridQuestions.isBankType?this.props.veridQuestions:null,
    veridQuestions: this.props.veridQuestions&&this.props.veridQuestions.isBankType ?[]:this.props.veridQuestions&&[...this.props.veridQuestions.data.attributes.questions].map((que, index)=>{
      que.choices.map((choice, index)=>{
        choice.isSelected=false;
      });
      return que;
    }),
    isContinueDisabled: true,
    kbvData: this.props.veridQuestions&&this.props.veridQuestions.isBankType?this.props.veridQuestions:null,
    cancelVerid: false,
    btnCheck: this.props.disableContinueBtnPerm?this.props.disableContinueBtnPerm:null
  };

  componentDidMount() {
    const appContainer=document.getElementById('dashboard-section');
    appContainer? appContainer.style.minHeight="1500px":null;
    const { pageName, siteSection }=veridDataLayer;
    updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
  }

  componentDidUpdate(prevProps, nextState){
    if(prevProps.veridQuestions !== this.props.veridQuestions && this.props.veridQuestions!==null && this.props.veridQuestions.isBankType ){
      this.setState({
        kbvData: this.props.veridQuestions
      });
    } else if(prevProps.veridQuestions !== this.props.veridQuestions && this.props.veridQuestions!==null && !this.props.veridQuestions.isBankType){
      this.setState({
        veridQuestions: this.props.veridQuestions&&this.props.veridQuestions.isBankType ?[]:this.props.veridQuestions&&[...this.props.veridQuestions.data.attributes.questions].map((que, index)=>{
          que.choices.map((choice, index)=>{
            choice.isSelected=false;
          });
          return que;
        })
      });
    }
  }

  handleAnswertSelection=(e, parentIndex, childIndex)=>{
    e.stopPropagation();
    let temp = [...this.state.veridQuestions];
    let tempChoices= [...temp[parentIndex].choices];
    tempChoices.map((choice, index)=>{
      if(index===childIndex){
        choice.isSelected=true;
      } else {
        choice.isSelected=false;
      }
    });
    temp.choices=tempChoices;
    let checkRadioSelection = temp.map(v=>{
      return v.choices.some(a=>a.isSelected==true);
    });
    let checkContinueDisable= checkRadioSelection.every(v=>v===checkRadioSelection[0]);

    this.setState({
      veridQuestions: temp,
      isContinueDisabled: !checkContinueDisable
    });
  };

  handleVeridContinueClick=()=>{
    let veridSelectedAnswers=this.state.veridQuestions.map(v=>{
      let selectedId=v.choices.filter(choice=>{
        return choice.isSelected==true;
      })[0].id;
      return {
        questionId: v.questionId,
        answerChoiceIds: [{ id: selectedId }]
      };
    });
    let formData={
      veridAnswersRequest: {
        answerslist: veridSelectedAnswers,
        verificationContextId: this.props.verificationContextsId
      }
    };
    //Submit VERID Answers
    this.props.submitVerid(formData, this.props.bankInfo, this.props.kbvType, this.props.challengeType);
  };

  render = () => {
    if (this.state.cancelVerid) {
      return <Redirect push to={addBankDetailsUrl} />;
    }
    let checkDisableBtn = (this.props.disableContinueBtnPerm == "update_power_curve") || (this.props.disableContinueBtnPerm =="approved")?true:this.state.isContinueDisabled;
    return (
      <div>
        {
          this.props.veridQuestions&& this.props.veridQuestions.isBankType ? <Kbv bankInfo={this.props.bankInfo} data={this.state.kbvData}/> : <div className="otp-page-font">
            <div className="otp-second-page veridPage">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 col-xs-12">

                    <div className="row">
                      <div className="col-md-12 col-xs-12 padding-between">
                        <h3 className="header-font standard-blue select-delivery">Answer your security
                            questions</h3>
                        <p>For your security please answer the question(s) below:
                          <span className="standard-msg-txt hidden-xs display-txt-next">We use this information to verify your identity, and protect your account, so you must correctly complete the question(s) BEFORE your request can be submitted.</span>
                        </p>

                        {
                          this.state.veridQuestions && this.state.veridQuestions.map((item, index)=> {
                            let parentIndex = index;
                            return <div className="col-md-12 col-xs-12" key={`verid-questions-${index}`}>
                              <p className="securepasscode-font standard-blue select-delivery idv-verid-que" >{item.question}</p>
                              <p className="txt-top" aria-label={item.hint}>{item.hint}</p>
                              <ul className="cl-list idv-verid-radio-list">
                                {
                                  item.choices.map((ans, index)=> {
                                    return <li className="cl-list-item radio-li"
                                      key={`multiple-choice-questions-${index}`}>
                                      <div className={`verid-radio-btn-wrapper`}>
                                        <div className={`verid-radio-input cl-rdio cl-rdio-primary radio-inline`}>
                                          <input
                                            value={ans.choice}
                                            id={`multiple-choice-${parentIndex}-${index}`}
                                            name={`verid-multiple-choice-${parentIndex}`}
                                            checked={ans.isSelected}
                                            type="radio"
                                            onClick={e=>this.handleAnswertSelection(e, parentIndex, index)}
                                            aria-labelledby={`verid-${parentIndex}-${index}`}
                                          />
                                          <label htmlFor={`multiple-choice-${parentIndex}-${index}`}
                                            className=""></label>
                                        </div>
                                        <div className="verid-radio-btn-label">
                                          <span id={`verid-${parentIndex}-${index}`}>
                                            {ans.choice}
                                          </span>
                                        </div>
                                      </div>
                                    </li>;
                                  })
                                }
                              </ul>
                            </div>;
                          })
                        }
                        <div className="row">
                          <div className="col-xs-12 col-md-12 col-sm-12">
                            <div className="verid-btns-wrapper">
                              <IDVButton id="ContinueBtnVerid"
                                title="Continue"
                                track="custom-links"
                                isButtonDisabled={checkDisableBtn}
                                onBtnClick={e=>this.handleVeridContinueClick()}
                                ariaLabel="Click to continue"/>
                              <IDVButton id="CancelBtnKbv"
                                title="Cancel"
                                track="custom-links"
                                toggleStyle={true}
                                onBtnClick={e=>this.setState({ cancelVerid: true })}
                                ariaLabel="Click to cancel"/>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    kbvQuestions: state.creditCardApplicant !==null?state.creditCardApplicant.kbvQuestions:null,
    disableContinueBtnPerm: state.creditCardApplicant.disableContinueBtnPerm
  };
};

const mapDispatchToProps = {
  submitVerid: submitVerid
};

export default connect(mapStateToProps, mapDispatchToProps)(Verid);

